import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { ErrorParserService, ParsedError } from '../../../services/error-parser.service';

@Component({
  selector: 'app-error-alert',
  standalone: false,
  templateUrl: './error-alert.component.html',
  styleUrl: './error-alert.component.scss',
})
export class ErrorAlertComponent implements OnChanges {
  @Input() error: any = null;
  @Input() dismissible: boolean = true;
  @Input() showFieldNames: boolean = true;

  parsedErrors: ParsedError[] = [];
  isVisible: boolean = false;

  constructor(private errorParser: ErrorParserService) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['error'] && this.error) {
      this.parsedErrors = this.errorParser.parseError(this.error);
      this.isVisible = this.parsedErrors.length > 0;
    } else if (changes['error'] && !this.error) {
      this.parsedErrors = [];
      this.isVisible = false;
    }
  }

  dismiss(): void {
    this.isVisible = false;
    this.parsedErrors = [];
  }

  getFieldLabel(field?: string): string {
    if (!field || !this.showFieldNames) return '';
    return field.replace(/_/g, ' ').replace(/\b\w/g, char => char.toUpperCase());
  }
}
